import { Link } from "react-router-dom";
import { Globe2 } from "lucide-react";

export default function AuthShell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between p-12" style={{ background: "#00294F" }}>
        <Link to="/" data-testid="auth-logo-link" className="flex items-center gap-2.5">
          <div className="w-9 h-9 bg-white flex items-center justify-center">
            <Globe2 className="w-5 h-5 text-[#0050A0]" aria-hidden="true" />
          </div>
          <span className="font-serif text-2xl font-bold text-white tracking-tight">makemytender<span className="text-[#009EDB]">.com</span></span>
        </Link>
        <div>
          <h2 className="font-serif text-4xl text-white leading-tight max-w-md">
            Global tenders, drafted to local law.
          </h2>
          <p className="text-sm text-slate-300 mt-6 max-w-md leading-relaxed">
            Float RFPs, NITs and EOIs compliant with the procurement law of the country of execution —
            with UNCITRAL and UN procurement rules as the global fallback.
          </p>
        </div>
        <p className="text-xs text-slate-400 tracking-wide">
          UNCITRAL Model Law · UN Procurement Manual · World Bank Regulations
        </p>
      </div>
      <div className="flex items-center justify-center p-8 bg-[#F8FAFC]">
        <div className="w-full max-w-md">
          <h1 className="font-serif text-3xl text-slate-900 mb-2">{title}</h1>
          <p className="text-sm text-slate-500 mb-8">{subtitle}</p>
          {children}
        </div>
      </div>
    </div>
  );
}
